"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Checks if a value is an array
 *
 * @Example
 *
 *   isArray([])
 *   //=> true
 *
 *   isArray(null)
 *   //=> false
 *
 *   isArray(undefined)
 *   //=> false
 */
function isArray(value) {
    return Array.isArray(value);
}
exports.isArray = isArray;
//# sourceMappingURL=is-array.js.map